import { render, staticRenderFns } from "./NeoparentDictionary.vue?vue&type=template&id=53b10330&scoped=true"
import script from "./NeoparentDictionary.vue?vue&type=script&lang=js"
export * from "./NeoparentDictionary.vue?vue&type=script&lang=js"
import style0 from "./NeoparentDictionary.vue?vue&type=style&index=0&id=53b10330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b10330",
  null
  
)

export default component.exports